import { combineReducers } from '@reduxjs/toolkit';
import licenseReducer from 'reducer/rLicense';
import messageBoxReducer from 'reducer/rMessageBox';
import authReducer from 'reducer/rAuth';
import clientReducer from 'reducer/rClient';
import productReducer from 'reducer/rProduct';
import contractReducer from 'reducer/rContract';
import validationReducer from 'reducer/rValidation';
import downloadReducer from 'reducer/rDownload';
import settingReducer from 'reducer/rSetting';

// 모든 리덕스를 합쳐주는 rootReducer
//
// 아직 이관하지 않은 것: 대시보드(Partner / Non-Partner 현황). 백엔드가 3단계에서 제거돼
// 부를 API 가 없다 - 이관이 아니라 재구축이다. TFL 마스터 라이선스는 폐기 대상이라 옮기지 않는다.
//
// 설정(메일)은 재구축했다. 인증 서버 URL 탭은 빼놨다 - 그 값은 발급 서버의
// TFL_AUTH_SERVER_URL 이 발급 시점에 add_flag 로 실어 보낸다.
//
// 파일 검증은 옮겼다. 형식 해석은 발급 서버가 소유하고 포탈은 파일을 넘기기만 한다.
// 다운로드 이력도 옮겼다. 이력을 쓰는 것은 발급 서버이고 포탈은 원장 쪽 표를 읽는다.
const rootReducer = combineReducers({
  license: licenseReducer,
  messageBox: messageBoxReducer,
  auth: authReducer,
  client: clientReducer,
  product: productReducer,
  contract: contractReducer,
  validation: validationReducer,
  download: downloadReducer,
  setting: settingReducer,
});

export default rootReducer;
